import { render, staticRenderFns } from "./SettingsMrDocumentHeaderFooter.vue?vue&type=template&id=6a1a9b9c"
import script from "./SettingsMrDocumentHeaderFooter.vue?vue&type=script&lang=js"
export * from "./SettingsMrDocumentHeaderFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports